'use client'

import React from 'react'
import { useEffect } from 'react'
import Script from 'next/script'

const TemplateJS = () => {
  const handleStickyHeader = () => {
    const header = document.querySelector('.header__main')
    if (header) {
      const stickyOffset = header.getBoundingClientRect().top + window.scrollY

      const onScroll = () => {
        if (window.scrollY > stickyOffset) {
          header.classList.add('sticky')
        } else {
          header.classList.remove('sticky')
        }
      }

      window.addEventListener('scroll', onScroll)
    }
  }

  useEffect(() => {
    // handlePopupToggle()
    handleStickyHeader()
  }, [])
  return (
    <>
      <Script
        id="Cookiebot"
        src="https://consent.cookiebot.com/uc.js"
        data-cbid="1ca244ff-1b22-45d4-a717-11a935a18258"
        data-blockingmode="none"
        data-cookieconsent="necessary"
        strategy="lazyOnload"
        type="text/javascript"
      />

      <Script
        id="broadstreet-watch"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `broadstreet.watch({ networkId: 9415 })`,
        }}
      />
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-R2EE9GSTBG"
        strategy="afterInteractive"
        id="ga-script"
      />
      <Script id="google-analytics" strategy="lazyOnload">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-R2EE9GSTBG');
          `}
      </Script>
    </>
  )
}

export default TemplateJS
